import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './pages/Home';
import Detail from './pages/Vaishno-devi';
import VishwanathTemple from './pages/Kashi-vishwanath'; 
import KedarnathTemple from './pages/Kedarnath-temple';  
import AmarnathTemple from './pages/Amarnath-temple';
import DwarkadhishTemple from './pages/Dwarkadhish-temple';
import RamanathaswamyTemple from './pages/Ramanathaswamy-temple';
import About from './pages/About';
import Header from './layout/header/Header';
import Footer from './layout/footer/Footer';
import Contact from './pages/Contact';
import RefundPolicy from './pages/Refund-policy';
import Privacy from './pages/Privacy';
import TermsCondition from './pages/terms';
import reportWebVitals from './reportWebVitals';
import Locker from './pages/Locker';
import DetailListing from './pages/listing/Listing';
import { Provider } from 'react-redux';
import store from './store/store';
import AyodhyaTemple from './pages/Ayodhya-temple';
import Career from './pages/Career';
import Thanks from './pages/Thanks'; 
import Hotel from './pages/hotel-page/hotel';
import HotelList from './pages/hotel-page/hotel-list';
import Vrdarshan from './pages/Vr-darshan';
import VrDarshanNew from './pages/vr-darshan/darshan-list';
import TrendingPage from './pages/trending/trending';
import FormUpload from './pages/forms/Upload-form';
import TrendingDetail from './pages/trending/trending-detail';
import ContestPage from './pages/contest/contest';
import Comingsoon from './pages/Coming-soon';
import NotFoundFun from './pages/404';
import HotelDetail from './pages/hotel-page/hotel-detail';
import HotelPayment from './pages/hotel-page/hotel-payment';
import VrShows from './pages/trending/vr-shows';
import VrExperience from './pages/trending/vr-experience';
import DeviTemple from './pages/trending/devi-temple';
import Jyotirlingas from './pages/trending/jyotirlingas';
import TrendingPageNew from './pages/trending/trending-new';
// navi stick start
import NaviStick from './pages/navi-stick/navi-stick';
import SarthPage from './pages/stick-pages/sarthi-page';
// navi stick end
import ReunitePage from './pages/reunite-page/reunite-page';
import YatriPack from './pages/yatri-pack/yatri-pack';
import IndiaMap from './pages/map/map';
import VaishnoDeviPackage from './pages/vaishno-devi-package/vaishno-devi-package';
import VaranasiPackage from './pages/varanasi-package/varanasi-package';
import HomePageWhite from './pages/homepage-new/homepage-new';
import TempleDetail from './pages/temple-detail/TempleDetail';
import BlogListing from './pages/blog/BlogListing';
import BlogDetail from './pages/blog/BlogDetail';
import KedarnathBlogDetail from './pages/blog/KedarnathBlogDetail';
import PitruPakshaBlogDetail from './pages/blog/PitruPakshaBlogDetail';
import VaishnoDeviBlogDetail from './pages/blog/VaishnoDeviBlogDetail';
import PackageListing from './pages/package-listing/package-listing';
import FooterNew from './layout/footer/Footer-new';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/old" element={<App />} />
          <Route path="/vaishno-devi" element={<Detail />} />
          <Route path="/kashi-vishwanath" element={<VishwanathTemple />} /> 
          <Route path="/kedarnath" element={<KedarnathTemple />} /> 
          <Route path="/amarnath" element={<AmarnathTemple />} />
          <Route path="/dwarkadhish-temple" element={<DwarkadhishTemple />} />
          <Route path="/ramanathaswamy-temple" element={<RamanathaswamyTemple />} />
          <Route path="/ayodhya" element={<AyodhyaTemple />} /> 
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/locker" element={<Locker />} />
          <Route path="/listing" element={<DetailListing />} />
          <Route path="/regions/:regionId" element={<DetailListing />} />
          <Route path="/regions" element={<DetailListing />} />
          <Route path="/career" element={<Career />} />
          <Route path="/thanks" element={<Thanks />} />
          <Route path="/hotel" element={<Hotel />} />
          <Route path="/hotel-list" element={<HotelList />} />
          <Route path="/hotel-detail" element={<HotelDetail />} />
          <Route path="/payment" element={<HotelPayment />} />
          <Route path="/vr-darshan-old" element={<Vrdarshan />} />
           <Route path="/vr-darshan-new" element={<VrDarshanNew />} />
          <Route path="/vr-darshan" element={<TrendingPageNew />} />
          <Route path="/trending-detail" element={<TrendingDetail />} />
<Route path="/upload-form" element={<FormUpload />} />
          <Route path="/contest" element={<ContestPage />} />
          <Route path="/vr-shows" element={<VrShows />} />
          <Route path="/devi-temple" element={<DeviTemple />} />
          <Route path="/vr-experience" element={<VrExperience />} />
          <Route path="/jyotirlingas" element={<Jyotirlingas />} />
          <Route path="/coming-soon" element={<Comingsoon />} />
          <Route path="/landingpage/app" element={<Comingsoon />} />
          <Route path="/navi-stick" element={<NaviStick />} />
          <Route path="/sarthi-service" element={<SarthPage />} />
          <Route path="/reunite-band-service" element={<ReunitePage />} />
          <Route path="/yatri-pack" element={<YatriPack />} />
          <Route path="/india-map" element={<IndiaMap />} />
          <Route path="/india-temples" element={<IndiaMap />} />
          <Route path="/vaishno-devi-package" element={<VaishnoDeviPackage />} />
          <Route path="/varanasi-package" element={<VaranasiPackage />} />
          <Route path="/packages" element={<PackageListing />} />
          <Route path="/package-listing" element={<PackageListing />} />
          <Route path="/" element={<HomePageWhite />} />
          <Route path="/temple/:slug" element={<TempleDetail />} />
          <Route path="/temple" element={<TempleDetail />} />
          <Route path="/temple-detail/:slug" element={<TempleDetail />} />
          <Route path="/temple-detail" element={<TempleDetail />} />
          <Route path="/temples" element={<TempleDetail />} />
          <Route path="/blog" element={<BlogListing />} />
          <Route path="/blog-listing" element={<BlogListing />} />
          <Route path="/blog/anant-chaturdashi-ganesh-visarjan" element={<BlogDetail />} />
          <Route path="/blog/anant-chaturdashi-2026" element={<BlogDetail />} />
          <Route path="/blog/anant-chaturdashi-2026-ganesh-visarjan" element={<BlogDetail />} />
          <Route path="/anant-chaturdashi-ganesh-visarjan" element={<BlogDetail />} />
          <Route path="/anant-chaturdashi-2026" element={<BlogDetail />} />
          <Route path="/blog/kedarnath-temple-history-and-pandava-story" element={<KedarnathBlogDetail />} />
          <Route path="/blog/kedarnath-temple-history" element={<KedarnathBlogDetail />} />
          <Route path="/blog/kedarnath-temple-pandav-katha" element={<KedarnathBlogDetail />} />
          <Route path="/blog/kedarnath-temple" element={<KedarnathBlogDetail />} />
          <Route path="/blog/kedarnath" element={<KedarnathBlogDetail />} />
          <Route path="/kedarnath-temple-history-and-pandava-story" element={<KedarnathBlogDetail />} />
          <Route path="/blog/pitru-paksha-crow-significance-shradh-puja-vidhi" element={<PitruPakshaBlogDetail />} />
          <Route path="/blog/vaishno-devi-story-shridhar-bhairavnath" element={<VaishnoDeviBlogDetail />} />
          <Route path="/blog-detail" element={<BlogDetail />} />
          <Route path="/blog-detail/:slug" element={<BlogDetail />} />
          {/* extra pages */}
          <Route path="/vr-darshan-extra" element={<TrendingPage />} />
          <Route path="*" element={<NotFoundFun />} />
        </Routes>
        <FooterNew />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
